<template>
    <div>
        <form @submit.prevent="onSubmit">
            <b-form-checkbox v-model="userAnonymous" @change="handleUserReset">
                <span class="ms-1">
                    Denuncia anónima
                </span>
            </b-form-checkbox>

            <!-- opcion usuario -->
            <div v-if="!userAnonymous">
                <div class="card mb-2">
                    <div class="card-body">

                        <div class="form-group mb-1">
                            <label for="email">Correo electrónico</label>
                            <div class="input-group">
                                <span class="input-group-text" id="email-addon">@</span>
                                <input v-model="accuser.mail" type="email" class="form-control" id="email"
                                    placeholder="usuario@compliance.cl" aria-describedby="email-addon"
                                    @change="handleUserReset">
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="fullname">Nombre completo</label>
                            <div class="input-group">
                                <span class="input-group-text" id="name-addon">
                                    <b-icon icon="file-earmark-person"></b-icon>
                                </span>
                                <input v-model="accuser.name" type="text" class="form-control" id="fullname"
                                    placeholder="Juan Perez" aria-describedby="name-addon">
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <hr>
            <DenounceQuestions :key="questionsKey" v-model="questions" @update="updateQuestions" />
            <hr>

            <div class="form-group col-auto mb-3 mt-0">
                <label for="fileInput">Adjuntar evidencia</label>
                <input type="file" class="form-control" id="fileInput" ref="fileInput" @change="handleFileChange" accept=".pdf">
            </div>

            <div class="form-group row">
                <div class="col-sm-3">
                    <button type="submit" class="btn btn-primary w-100" :disabled="isUploading">
                        <b-spinner small v-show="isUploading"></b-spinner>
                        Denunciar
                    </button>
                </div>
                <div class="col-sm-9" v-show="progress">
                    <ProgressCustom ref="progressBar"></ProgressCustom>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import DenounceQuestions from '@/components/Denounce/DenounceMenu/DenounceForm/Denounce-questions.vue'
import ProgressCustom from '@/components/shared/Progress-custom.vue';
import { EventNames, InitPageSize } from '@/plugins/enums';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'DenounceForm',

    components: {
        DenounceQuestions,
        ProgressCustom
    },

    data() {
        return {
            userAnonymous: true,
            file: null,

            questions: [],
            accuser: {
                name: '',
                mail: ''
            },

            form: {
                accuserId: null,
                route: null
            },

            isUploading: false,
            progress: 0,

            questionsKey: 0
        }
    },

    computed: {
        ...mapGetters(["getSession"]),
    },

    methods: {
        ...mapActions([
            "createDenunciation",
            "getAccusersByMail",
            "updateFileDenunciation",
            "createAccusersAnonymous",
        ]),

        async onSubmit() {
            this.isUploading = true;

            if (!this.userAnonymous && !this.form.accuserId) {
                this.setProgress(10, "Obteniendo información denunciante...")
                let accuserResult = await this.getAccuserId()
                if (!accuserResult) {
                    this.resetSubmitProcess();
                    return;
                }
            }

            if (this.file && !this.form.route) {
                this.setProgress(20, "Subiendo documento evidencia...")
                let uploadResult = await this.uploadFile()
                if (!uploadResult) {
                    this.resetSubmitProcess();
                    return;
                }
            }

            this.setProgress(80, "Creando denuncia...")
            let result = await this.saveDenunciation();
            if (!result) {
                this.resetSubmitProcess();
                return;
            }

            this.setProgress(100, "Completado")
            setTimeout(() => {
                this.setProgress(0)
            }, 1000)

            this.$eventBus.$emit(EventNames.CreateDenunciation, {
                page: 1,
                pageSize: InitPageSize.DenouncePageSize
            });

            this.showAlert('Denuncia enviada correctamente', 'success')

            this.clear()

            this.isUploading = false;
        },

        async getAccuserId() {
            let user = await this.getAccuserIdFromMail();
            if (user) {
                this.form.accuserId = user.id;
                return true;
            }

            let userIdResult = await this.createAccusersAnonymous({
                name: this.accuser.name,
                mail: this.accuser.mail
            });

            if (userIdResult.isError) {
                this.showAlert(userIdResult.message);
                return false;
            }

            this.form.accuserId = userIdResult.data;
            return true;
        },

        async getAccuserIdFromMail() {
            let result = await this.getAccusersByMail({ mail: this.accuser.mail });

            if (result.isError) {
                this.showAlert(result.message);
                return false;
            }

            return result.data
        },

        async uploadFile() {
            if (!this.file) {
                this.showAlert('Debe seleccionar un archivo.');
                return false;
            }

            let result = await this.updateFileDenunciation(this.file);

            if (result.isError) {
                this.showAlert(result.message);
                return false;
            }

            this.form.route = result.data;
            return true;
        },

        async saveDenunciation() {
            let form = { ...this.form }
            let answers = this.questions.map((q) => {
                return {
                    questionId: q.id,
                    answerValue: q.respuesta
                }
            })

            form.answers = answers;
            let result = await this.createDenunciation(form);

            if (result.isError) {
                this.showAlert(result.message);
                return false;
            }

            return true
        },

        updateQuestions(questions) {
            this.questions = questions;
        },

        handleFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                this.file = file
                this.form.route = null
            }
        },

        handleUserReset() {
            this.form.accuserId = null
        },

        setProgress(value, message = '') {
            this.progress = value;
            this.$refs.progressBar.progress(value, message);
        },

        resetSubmitProcess() {
            this.setProgress(0)
            this.isUploading = false;
        },

        clear() {
            this.accuser.name = ""
            this.accuser.mail = ""
            this.file = null
            this.$refs.fileInput.value = null

            this.form.accuserId = null
            this.form.route = null
            this.questionsKey += 1
        },

        showAlert(message, type) {
            this.$emit('alert', message, type)
        }
    }
}
</script>